<template>
    <div class="flex  flex-wrap justify-evenly mt-10">
        <a href="#"
            class="block  md:mb-0 mb-5 h-fit bg-till-date max-w-sm p-5 w-[300px]   border border-gray-200 rounded-lg shadow  dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
            <div class="flex justify-between">
            <h6 class="mb-2 text-[15px] font-family-card tracking-tight text-white dark:text-white">Till Date</h6>
            <h6 class="font-family-card   text-white">(KG's)</h6>
            </div>
            <div class="font-family-card pt-1  flex flex-wrap justify-between text-white dark:text-gray-400">
                <h1 class="text-xs">Disposed</h1>
                <h1 class="text-sm"> {{ formatNumber(cardDataincineration.tillDateIncinerationCount) }}</h1>
            </div>
        </a>
        <a href="#"
            class="block  h-fit bg-current-year max-w-sm p-5 w-[300px]   border border-gray-200 rounded-lg shadow  dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
            <div class="flex justify-between">
            <h6 class="mb-2 text-[15px] tracking-tight text-white dark:text-white">Current Year</h6>
            <h6 class="font-family-card   text-white">(KG's)</h6>
            </div>
            <div class="font-family-card pt-1  font-family-card flex flex-wrap justify-between text-white dark:text-gray-400">
                <h1 class="text-xs">Disposed</h1>
                <h1 class="text-sm"> {{ formatNumber(cardDataincineration.currentYearIncinerationCount) }}</h1>

            </div>

        </a>
    </div>
    <div class="flex flex-wrap justify-evenly mt-6">
        <a href="#"
            class="block md:mb-0 mb-5 h-fit bg-current-month max-w-sm p-5 w-[300px]   border border-gray-200 rounded-lg shadow  dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
            <div class="flex justify-between">
            <h6 class="mb-2 text-[15px] tracking-tight text-white dark:text-white">Current Month</h6>
            <h6 class="font-family-card   text-white">(KG's)</h6>
            </div>
            <div class="font-family-card pt-1  flex flex-wrap justify-between text-white dark:text-gray-400">
                <h1 class="text-xs">Disposed</h1>
                <h1 class="text-sm"> {{ formatNumber(cardDataincineration.currentMonthIncinerationCount) }}</h1>
            </div>
        </a>
        <a href="#"
            class="block  h-fit bg-current-week max-w-sm p-5 w-[300px]   border border-gray-200 rounded-lg shadow  dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
            <div class="flex justify-between">
            <h6 class="mb-2 text-[15px] tracking-tight text-white dark:text-white">Current Week</h6>
            <h6 class="font-family-card   text-white">(KG's)</h6>
            </div>
            <div class="font-family-card pt-1 font-family-card flex flex-wrap justify-between text-white dark:text-gray-400">
                <h1 class="text-xs">Disposed</h1>
                <h1 class="text-sm"> {{ formatNumber(cardDataincineration.currentWeekIncinerationCount) }}</h1>
            </div>
        </a>
    </div>
    <div class="flex flex-wrap justify-evenly mt-6 mb-10">
        <a href="#"
            class="block md:mb-0 mb-5 h-fit bg-current-day max-w-sm p-5 w-[300px]   border border-gray-200 rounded-lg shadow  dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
            <div class="flex justify-between">
            <h6 class="mb-2 text-[15px]font-family-card tracking-tight text-white dark:text-white">Current Day</h6>
            <h6 class="font-family-card   text-white">(KG's)</h6>
            </div>
            <div class="font-family-card pt-1  flex flex-wrap justify-between text-white dark:text-gray-400">
                <h1 class="text-xs">Disposed</h1>
                <h1 class="text-sm"> {{ formatNumber(cardDataincineration.currentDateIncinerationCount) }}</h1>
            </div>
        </a>
        <a href="#"
            class="  h-fit bg-white max-w-sm p-5 w-[300px]   border-white rounded-lg   ">
            <div class="flex justify-between">
            <h6 class="mb-2 hidden text-[15px]font-family-card tracking-tight text-white dark:text-white">Till Date - Progress</h6>
            <h6 class="font-family-card   text-white">(KG's)</h6>
            </div>
            <div class="font-family-card  flex flex-wrap justify-between text-white dark:text-gray-400">
                <!-- <h1>Disposed</h1> -->
                <!-- <h1> {{ formatNumber(cardDataincineration.tillDateIncinerationCount) }}</h1> -->

            </div>

        </a>
    </div>
</template> 


<script setup>

import { defineProps } from 'vue';

// Define the props to be received
const props = defineProps(['cardDataincineration']);

const formatNumber = (value) => {
  if (value !== undefined) {
    return value.toLocaleString();
  } else {
    return 0;
  }
};
</script>